import { useCallback } from 'react'

import { useAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { getLotsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

export const useDownloadManifest = () => {
  const accessToken = useAccessToken()

  return useCallback(
    async (lotId: string, listingTitle?: string) => {
      const { data } = await getLotsClient().exportManifest(
        { lotId },
        buildAxiosRequestConfig({ accessToken })
      )
      const createdUrl = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = createdUrl
      const truncatedTitle = listingTitle?.substring(0, 128) ?? lotId
      link.setAttribute('download', `BStock_${truncatedTitle}_Manifest.csv`)
      document.body.append(link)
      link.click()
      link.remove()
    },
    [accessToken]
  )
}
